import "./styles/leaderboard.css"
import { useState } from "preact/hooks"
import { Component, createRef } from "preact";
import socket from "src/utils/socket";
import Back from "./icon/back";

const Empty = ({ mode = 'light' }) => <span className={`tk-empty ${mode}`}>- Empty -</span>

export default class Leaderboard extends Component {
    constructor() {
        super()
        this.state = {
            userDataAssigned: false,
            user: {},
            leaderboard: [],
            achievements: [],
            visible: true,
            wss: null,
            feature: { loaded: false, checklist: true }
        }
    }

    #checklistAppear = createRef()

    #structure = (body, floating = true) => <div className={`${this.state.visible ? "leaderboard-wrapper" : "hide-leaderboard"} ${!floating && "not-floating"}`}><div class="leaderboard-content">{body}</div></div>
    #ranking = (rows) => rows.length == 0 ? <Empty mode={this.props.mode} /> : rows
    #section = (body) => <><h1 class="user-score-title title">Your Standing</h1>{body}<h1 class="user-score-title">Top {this.props.quantity || 10}</h1>
    </>
    #userInfo = ({ mode, eventId, headCard = false, achievementsOpen = false } = {}) =>
        this.#section(<LeaderRow
            eventId={eventId}
            userData={this.state.user}
            mode={mode}
            headCard={ this.state.feature.checklist && headCard}
            achievements={this.state.achievements}
            ref={this.#checklistAppear}
            achievementsOpen = {achievementsOpen}
        />)

    openLeaderboard = () => {
        this.setState({ visible: true })
    }

    closeLeaderboard = () => {
        this.setState({ visible: false })
    }

    toggleLeaderboard = () => {
        this.setState({ visible: !this.state.visible })
    }

    render({ eventId, mode = "light", entrypoint, hideClose = false, hideButtons = false, achievementsOpen = false, userId, quantity = 10, name = null, headshot = null, ...rest } = {}) {
        if (!entrypoint) return this.#structure(<Empty mode={mode} />)

        const {feature = {}} = rest
        
        if (!this.state.feature.loaded) this.setState({feature: {...this.state.feature, ...feature, loaded: true}})

        if(this.state.wss == null) {
            let wss = socket(entrypoint, true, userId)

            wss.onConnect(() => {
                wss.send(JSON.stringify({ type: "join", user: {userId, eventId, name, headshot}, message: {size: quantity}}))
            })

            this.setState({wss})
        }

        if (this.state.wss) {
            this.state.wss.addEvent("accepted", data => {
                data.forEach(ev => this.state.wss.send(JSON.stringify({ type: ev, user: {userId, eventId, name, headshot}, message: {size: quantity}})))
                this.setState({ userDataAssigned: true })
            })

            this.state.wss.addEvent("refresh", data => {
                data.forEach(ev => this.state.wss.send(JSON.stringify({ type: ev, user: {userId, eventId, name, headshot}, message: {size: quantity}})))
            })

            this.state.wss.addEvent("get-position", data => {
                this.setState({user: data})
            }) 

            this.state.wss.addEvent("get-ranking", data => {
                this.setState({leaderboard: data.map((row) => {
                    const splitName = row.name.split(" ")
                    const initials = splitName[0][0] + splitName[splitName.length - 1][0]
                    return {
                        ...row, initials
                    }
                })})
            })

            this.state.wss.addEvent("get-achievements", data => {
                this.setState({achievements: data})
            })
        }
        
        const rows = this.state.leaderboard.map(row => <LeaderRow userData={row} mode={mode} />)

        return this.#structure(<>
            { hideClose ? null : <button class="close" onClick={this.closeLeaderboard}>x</button>}
            {this.state.leaderboard.length > 0 ?
                <div class="podium hide-podium">
                    <div class="crown-wrapper">
                        <img src="https://static1.tkevents.io/assets/images/king.png" alt="" class="crown" />
                    </div>
                    <div class="registrants">
                        <div class="podium-image-wrapper podium-second">
                            { this.state.leaderboard[1] ?
                                (this.state.leaderboard[1] && this.state.leaderboard[1].headshot ? <img src={this.state.leaderboard[1].headshot} alt="" class="podium-image" /> : <div class="podium-initials">{this.state.leaderboard[1].initials}</div>)
                                : null
                            }
                        </div>
                        <div class="podium-image-wrapper podium-first">
                            { this.state.leaderboard[0] ?
                                (this.state.leaderboard[0] && this.state.leaderboard[0].headshot ? <img src={this.state.leaderboard[0].headshot} alt="" class="podium-image" /> : <div class="podium-initials">{this.state.leaderboard[0].initials}</div>)
                                : null
                            }
                        </div>
                        <div class="podium-image-wrapper podium-third">
                            { this.state.leaderboard[2] ?
                                (this.state.leaderboard[2].headshot ? <img src={this.state.leaderboard[2].headshot} alt="" class="podium-image" /> : <div class="podium-initials">{this.state.leaderboard[2].initials}</div>)
                                : null
                            }
                        </div>
                    </div>
                    <div class="standings">
                        <div class="top-3-box two">2</div>
                        <div class="top-3-box podium-1">1</div>
                        <div class="top-3-box three">3</div>
                    </div>
                </div>
                : null}
            {this.#userInfo({ data: this.state.user, mode, eventId, headCard: true, achievementsOpen })}
            {this.#ranking(rows)}
            { hideButtons ? null : 
                <div class="bottom-buttons-wrapper">
                    <button onclick={(ev) => { this.#checklistAppear.current.toggleAchievements() }} class="bottom-buttons leaderboard-checklist">Checklist</button>
                </div>
            }
        </>, rest.floating)
    }
}

const Achievements = ({ achievements = [], position = null, closeFunc = () => { } }) => {
    return <div class="checklist-wrapper cover">
        <div class="checklist-navbar">
            <div onClick={closeFunc} class="checklist-close">
                <Back/>
            </div>
            <h1 class="user-score-title title">Checklist</h1>
            <div></div>
        </div>
        {achievements.map(row => <AchievementRow {...row} />)}
    </div>
}

const AchievementRow = ({ achieved, name, points, times = 0, description = false, ...rest }) => {
    const checkboxClick = (e) => e.preventDefault()
    const { startDate, endDate, active } = rest

    let extraText = ""

    if (startDate && new Date(startDate) > new Date()) extraText = `Starting at ${startDate}`
    if (endDate && new Date(endDate) < new Date()) extraText = `Ended at ${startDate}`

    let disabledClass = ""
    if (!active) disabledClass = achieved ? "disabled" : "l-disabled"

    return <div class={`checklist-cards-wrapper ${disabledClass}`}>
        <div class="checklist-card">
            <input onClick={checkboxClick} type="checkbox" checked={achieved} disabled={!active} class="checklist-checkbox" />
            <div class="checklist-title">
                {name}
                {!active ? <p class="expiration-text">{extraText}</p> : null}
            </div>
            <div class="checklist-points-wrapper">
                <div class="checklist-points-number">+{points}</div>
                <div class="checklist-points-title">Points</div>
            </div>
        </div>
    </div>
}

const LeaderRow = function ({ userData, mode, headCard = false, achievements = [], achievementsOpen = false } = {}) {
    const [showAchievements, setShowAchievements] = useState(achievementsOpen && headCard)
    const [position, setPosition] = useState(null)

    this.toggleAchievements = () => setShowAchievements(prev => !prev)

    this.onClick = (ev) => {
        const leaderboardElement = ev.path.find(x => x && x.className && x.className.split(" ").find(y => y == "leaderboard-wrapper"))
        if (leaderboardElement) {
            const [left, right] = [leaderboardElement.getBoundingClientRect().left, leaderboardElement.getBoundingClientRect().right];

            if (window.visualViewport.width - right > 250) setPosition("right")
            else if (left > 250) setPosition("left")
            else setPosition(null)
        }
    }

    const rowClass = userData.headshot ? "top-player-card image" : "top-player-card"

    return <>
        {showAchievements ? <Achievements achievements={achievements} position={position} closeFunc={this.toggleAchievements} /> : null}
        <div onClick={headCard ? this.onClick : null} className={`noselect ${rowClass} ${mode} ${headCard ? "user" : ""}`}>

            <div class="player-card-column-1">
                <div class="rank">{userData.position}</div>
                <div class="headshot">
                    {userData.headshot ? <img className="player-card-image" src={userData.headshot} /> : <div class="no-headshot"></div>}
                </div>
                <div class="user-name">{userData.name}</div>
            </div>
            <div class="score">{userData.points} pts</div>
        </div>
    </>
}

export const assignAchievement = async ({ entrypoint = "https://leaderboardb.swoogo-retrofit.tkevents.io", achievementId, userId, eventId }) => {
    const url = `${entrypoint}/${userId}/${achievementId}/${eventId}/assign`
    const req = await fetch(url, { method: 'POST' }).catch(() => {
        return null;
    })

    if (req === null || req.status > 399) return [false, null]
    if (req.status == 201) return [true, null]
    else try {
        return [true, await req.json()]
    } catch (e) { return [true, null] }
}
